import { pickBy } from 'lodash'

import moment from 'moment'

const ExpiresInDays = 14

export default class Report {
  /**
   * Create new report and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    this.expiresIn = this.expirationDateTime ? moment(new Date(this.expirationDateTime)) : moment(this.generatedAt).add(ExpiresInDays, 'day')
    this.status = this.expiresIn.diff(moment(), 'hours') > 0 ? obj.status : 'Expired'

    const { startDate = null, endDate = null, pageSize, pageNumber, ...filters } = obj.filters

    this.startDate = startDate
    this.endDate = endDate
    this.filters = pickBy(filters) // filter out the `null` values
  }

  /**
   * @return {Date}
   */
  get startDate () {
    return this._startDate
  }

  /**
   * @param {string} value
   */
  set startDate (value) {
    this._startDate = value ? new Date(value) : null
  }

  /**
   * @return {Date}
   */
  get endDate () {
    return this._endDate
  }

  /**
   * @param {string} value
   */
  set endDate (value) {
    this._endDate = value ? new Date(value) : null
  }

  /**
   * @return {Date}
   */
  get queuedAt () {
    return this._queuedAt
  }

  /**
   * @param {string} value
   */
  set queuedAt (value) {
    this._queuedAt = value ? new Date(value) : null
  }

  /**
   * @return {Date}
   */
  get generatedAt () {
    return this._generatedAt
  }

  /**
   * @param {string} value
   */
  set generatedAt (value) {
    this._generatedAt = value ? new Date(value) : null
  }

  /**
   * @return {Date}
   */
  get deletedAt () {
    return this._deletedAt
  }

  /**
   * @param {string} value
   */
  set deletedAt (value) {
    this._deletedAt = value ? new Date(value) : null
  }
}
